import type { SVGProps } from 'react';

const Stop = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.25 5.75H6.75C6.19772 5.75 5.75 6.19772 5.75 6.75V17.25C5.75 17.8023 6.19772 18.25 6.75 18.25H17.25C17.8023 18.25 18.25 17.8023 18.25 17.25V6.75C18.25 6.19772 17.8023 5.75 17.25 5.75Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Stop;
